import { Injectable, signal } from '@angular/core';

/**
 * Cross-component clock-stamp event bus (story 35-1, F16a): the topbar
 * quick-stamp button bumps `version` after every successful clock-in/out;
 * "Deine Woche" folds the signal into its resource params so the week view
 * reloads immediately (same signal-refresh pattern as the approvals badge,
 * story 34-1). App-local on purpose — the layout consumes the button eagerly.
 */
@Injectable({ providedIn: 'root' })
export class ClockStampEventsService {
  private readonly _version = signal(0);
  /** Monotone counter — bumps after every successful clock-in/out. */
  readonly version = this._version.asReadonly();

  /** Called by the stamp button after a successful clock-in/out. */
  notifyStampChanged(): void {
    this._version.update(version => version + 1);
  }
}
